<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
    <router-view />
    <!-- <Auth /> -->
    
  </div>
</template>

<script>
import styles from '@/assets/css/standard.css';
// import Auth from "@/components/Auth.vue";
// import css from '@/assets/css/theme_default.css';
// import Footer from "@/components/Footer.vue";

export default {
  components: {
    // Auth,
    // Footer
  }
};
</script>
<style>
 /* @import '/css/theme_dark.css'; */
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
} */
</style>
